'use client';

import { createContext, useContext } from 'react';

const ModalTitleIdContext = createContext<string | undefined>(undefined);

export const ModalTitleIdProvider = ModalTitleIdContext.Provider;

export function useModalTitleId() {
  return useContext(ModalTitleIdContext);
}
